import alertModal from "./alert-modal";
import loadingModal from "./loading-modal";
import expiredAlertModal from "./expired-alert-modal";
import multiActionModal from "./multi-modal";
import updateAppModal from "./modal-update";

const modalTypes = {
  alertModal,
  loadingModal,
  expiredAlertModal,
  multiActionModal,
  updateAppModal,
};

export default modalTypes;
